var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M653,199.4h9.5V140h-10.9h-32.3H375.1H347h-15.2v59.4H347H653z M741.5,19.8h-60.4V275h60.4V19.8z M314.7,19.8h-60.4V275h60.4V19.8z M928.2,141.4H803.3h-28.1H760v59.4h15.2h151.6v120.2H71.8V200.8h153h12.3v-59.4h-12.3h-32.3H71.8H10v59.4v120.2v59.4v540.3v59.4h61.8h856.5H990v-59.4V380.5v-59.4V200.8v-59.4H928.2z M926.8,920.8H71.8V380.5h855.1V920.8z M289.2,446.6h-94.3v92.8h94.3L289.2,446.6L289.2,446.6z M547.1,446.6h-94.3v92.8h94.3V446.6z M805.1,446.6h-94.3v92.8h94.3V446.6z M289.2,603.5h-94.3v92.8h94.3L289.2,603.5L289.2,603.5z M547.1,603.5h-94.3v92.8h94.3V603.5z M805.1,603.5h-94.3v92.8h94.3V603.5z M289.2,760.3h-94.3v92.8h94.3L289.2,760.3L289.2,760.3z M547.1,760.3h-94.3v92.8h94.3V760.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/datePicker.454ac56362a89ea09d78f22322132694.svg";
export { ForwardRef as ReactComponent };